export default "__VITE_ASSET__815dbcbf__"